import { DataServer } from "../../../config.axios";
import { createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import decryptData from "../../../reusable/decryptData";

interface LogoutUserState {
    logoutuser: {
        load: boolean;
        data: [];
    };
}

export const logoutUserSlice = createSlice({
    name: "logoutuser",
    initialState: {
        logoutuser: {
            load: false,
            data: [],
        },
    } as LogoutUserState,
    reducers: {},
});

export default logoutUserSlice.reducer;

export const LogoutUser = (navigate?: Function) => async (dispatch: Function) => {
    const loginUserData = decryptData();
  
    if (loginUserData?.token) {
      try {
        dispatch(toggleLoading());
        const { data } = await DataServer.post("api/logout");
  
        return data;
      } catch (error) {
      }
    }
  };
